import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import API from "../../services/api";
import NoImage from "../../assets/images/NoImage.png";
import LocationSVG from "../../assets/images/location.svg";
import { formatDate } from "../../utils/dateFormat";
import {
  FullImage,
  Fullvideo,
  FullVideoOrGif,
  PromotedGallery,
  PromotedVideo,
  PromotedImage,
  CommentAd,
  WebView,
  Gallery,
  HalfVideo,
} from "../SalesPanel/BirdViewData";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import { toLakhs } from "../../utils/constants";
function AdsPreviewer(props) {
  const { data, w2nData, loader } = props;
  const [newspaperData, setNewsPaperData] = useState([]);
  const [imgSrc, setImgSrc] = useState("");
  const [see, setSee] = useState(false);
  const [locations, setLocations] = useState([]);
  const fetchNewsPapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setNewsPaperData([...res.data]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const loadLocations = useCallback(async () => {
    try {
      const response = await API({
        // url: `/birdview/birdviewLocations`,
        url: `/birdview/newspaper_locations`,
        method: "POST",
        responseType: "json",
      });
      if (response?.code === 200) {
        setLocations([...response?.data?.result]);
      } else {
        console.error(response.message);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);
  const locationObject = useMemo(() => {
    const obj = {};
    locations.forEach((location) => {
      obj[location.value] = location.label;
    });
    return obj;
  }, [locations]);
  useEffect(() => {
    loadLocations();
  }, []);

  useEffect(() => {
    fetchNewsPapers();
  }, []);

  const getColors = (brand) => {
    const brandLookup = newspaperData.filter((np) => np.name === brand);
    return {
      backgroundColor: brandLookup[0]?.background_color,
      color: brandLookup[0]?.color,
    };
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const handleCompClose = () => {
    props.setShowCompPreviews(false);
    props.setData([]);
  };
  const handleW2nClose = () => {
    props.setShowW2npreviews(false);
    props.setW2nData([]);
  };

  /* ------------------------- SUMMARY FOR newspaper (unchanged) ------------------------- */
  const grouped = data.reduce((acc, item) => {
    const key = `${item.date}-${item.ad_format}`;

    if (!acc[key]) {
      acc[key] = {
        date: item.date,
        ad_format: item.ad_format,
        count: 0,
        total_spent: 0
      };
    }

    acc[key].count += 1;
    acc[key].total_spent += Number(item.estimated_value || 0);

    return acc;
  }, {});
  const groupedArray = Object.values(grouped);
  groupedArray.sort((a, b) => new Date(a.date) - new Date(b.date));

  const totalData = data.reduce(
    (acc, item) => {
      acc.count += 1;
      acc.total_spent += Number(item.estimated_value || 0);
      return acc;
    },
    { count: 0, total_spent: 0 }
  );

  /* ------------------------- ADDED: SUMMARY FOR W2N SECTION ------------------------- */
  const groupedW2N = w2nData.reduce((acc, item) => {
    const key = `${item.date}-${item.sub_type}`;

    if (!acc[key]) {
      acc[key] = {
        date: item.created_date,
        ad_format: item.sub_type,
        count: 0,
        total_spent: 0
      };
    }

    acc[key].count += 1;
    acc[key].total_spent += Number(item.spent || 0);

    return acc;
  }, {});
  const groupedW2NArray = Object.values(groupedW2N);
  groupedW2NArray.sort((a, b) => new Date(a.date) - new Date(b.date));

  
  const totalW2N = w2nData.reduce(
    (acc, item) => {
      acc.count += 1;
      acc.total_spent += Number(item.spent || 0);
      return acc;
    },
    { count: 0, total_spent: 0 }
  );

  return (
    <>
      <SlDrawer
        open={props.showCompPreviews}
        style={{ "--size": "80%" }}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleCompClose}
      >
        <div className="my-4">
          <h4>Summary</h4>
          {data?.length && !loader ? (
            <table className="w-full  border-black border-collapse">
              <thead>
                <tr>
                  <th className="border-t border-b border-r px-4 py-2">Date</th>
                  <th className="border-t border-b border-r px-4 py-2" title={totalData?.count}>Count ({toLakhs(totalData?.count)})</th>
                  <th className="border-t border-b border-r px-4 py-2">Ad Format</th>
                  <th className="border-t border-b border-r px-4 py-2" title={totalData?.total_spent}>Total Spent ({toLakhs(totalData?.total_spent)})</th>
                </tr>
              </thead>
              <tbody>
                {groupedArray.map((row, index) => (
                  <tr key={index}>
                    <td className="border-t border-b border-r px-4 py-2">{formatDate(row.date)}</td>
                    <td className="border-t border-b border-r px-4 py-2">{row.count}</td>
                    <td className="border-t border-b border-r px-4 py-2">{row.ad_format}</td>
                    <td className="border-t border-b border-r px-4 py-2" title={row.total_spent}>{toLakhs(row.total_spent)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : !data?.length && !loader ? null : (
            <div class="d-flex justify-content-center mx-auto">
              <div class="spinner-border" role="status">
                {/* <span class="sr-only">Loading...</span> */}
              </div>
            </div>
          )}
        </div>
        <div
          className={`d-flex flex-wrap ${
            props.from !== "market" ? "dashBoardBird" : "marketDashboardBird"
          } border-b-2 border-gray-500`}
        >
          {data?.length && !loader ? (
            <div class="birdviewWrapper m-0 border-b-2">
              <ul class="birdview grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                {data.map((item, index) => {
                  return (
                    <li>
                      <div class="theme">
                        {item?.image_url ? (
                          <img src={item.image_url} alt="ads" />
                        ) : (
                          <img src={NoImage} alt="ad" />
                        )}
                        <div class="blur">
                          {" "}
                          {item?.image_url ? (
                            <img src={item.image_url} alt="ad" />
                          ) : (
                            <img src={NoImage} alt="ad" />
                          )}
                        </div>
                        <div class="publisher">
                          {item?.newspaper_name ? (
                            <h6 style={getColors(item?.newspaper_name)}>
                              {item.newspaper_name}
                            </h6>
                          ) : null}
                          {item?.ad_type === "Local" ? (
                            <h6 class="local">{item.ad_type}</h6>
                          ) : item?.ad_type === "National" ? (
                            <h6 class="national">{item.ad_type}</h6>
                          ) : (
                            <h6 class="districts">{item.ad_type}</h6>
                          )}
                        </div>
                        {item.location ? (
                          <p className="location">
                            <img
                              src={LocationSVG}
                              alt="location_name"
                              title={locationObject[item.location]}
                            />
                            {locationObject[item.location]}
                          </p>
                        ) : null}
                        <p class="estimation">
                          Est Val: <strong>{item.estimated_value || 0}</strong>
                        </p>
                        {/* Selcter CheckBox */}
                        {/* <div class="radioGroup">
                                                  <input type="checkbox" id={item.id} checked={selectedRecords.includes(item.id)}
                                                      onChange={() => toggleCheckbox(item.id)} />
                                                  <label for={item.id}></label>
                                              </div> */}
                        {item.image_url ? (
                          <Button
                            className="previewBtn"
                            variant="neutral"
                            onClick={() => {
                              setImgSrc(item.image_url);
                              setSee(true);
                            }}
                          >
                            Preview
                          </Button>
                        ) : null}
                      </div>
                      <div class="description">
                        {item?.page_no ? (
                          <p>
                            Page {item.page_no} : {formatDate(item.date)}
                          </p>
                        ) : (
                          <p>Page - : {formatDate(item.date)}</p>
                        )}
                        {/* <h1>{item.advertisers[0].adv_name || " "}</h1> */}
                        <h1>{item.campaign_name || " "}</h1>
                        <div className="grid grid-cols-2 gap-4 justify-between items-center">
                          <div>
                            <h5>Edition : {item.edition || " "}</h5>
                            {/* <h5>Page Name : {item.edition || " "}</h5> */}
                            <h5>Ad Format : {item.ad_format || " "} </h5>
                          </div>
                          <div>
                            {item?.dimensions?.area && item?.dimensions?.w && item?.dimensions?.h && <h5>Area : {item?.dimensions?.area +` (${item?.dimensions?.w} * ${item?.dimensions?.h})`|| " "}</h5>}
                            {!['null','undefined'].includes(item?.dimensions?.color) && <h5>Color : {item?.dimensions?.color ? "Color" :"B&W" || " "} </h5>}
                            {item?.dimensions?.price_per_unit && <h5>Price Per Sqcm : {item?.dimensions?.price_per_unit || " "} </h5>}
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : !data?.length && !loader ? null : (
            <div class="d-flex justify-content-center mx-auto">
              <div class="spinner-border" role="status">
                {/* <span class="sr-only">Loading...</span> */}
              </div>
            </div>
          )}
        </div>
      </SlDrawer>

      {/* ---------------- W2N DRAWER WITH NEW SUMMARY TABLE ---------------- */}
      <SlDrawer
        open={props.showW2nPreviews}
        style={{ "--size": "50%" }}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleW2nClose}
      >

        <div className="my-4">
          <h4>Summary</h4>

          {w2nData?.length ? (
            <table className="w-full border-black border-collapse">
              <thead>
                <tr>
                  <th className="border-t border-b border-r px-4 py-2">Date</th>
                  <th className="border-t border-b border-r px-4 py-2" title={totalW2N?.count}>Count ({toLakhs(totalW2N?.count)})</th>
                  <th className="border-t border-b border-r px-4 py-2">Ad Format</th>
                  <th className="border-t border-b border-r px-4 py-2" title={totalW2N.total_spent}>Total Spent ({toLakhs(totalW2N.total_spent)})</th>
                </tr>
              </thead>
              <tbody>
                {groupedW2NArray.map((row, index) => (
                  <tr key={index}>
                    <td className="border-t border-b border-r px-4 py-2">{formatDate(row.date)}</td>
                    <td className="border-t border-b border-r px-4 py-2">{row.count}</td>
                    <td className="border-t border-b border-r px-4 py-2">{row.ad_format}</td>
                    <td className="border-t border-b border-r px-4 py-2" title={row.total_spent}>{toLakhs(row?.total_spent)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : null}
        </div>


  <div className="d-flex flex-wrap ">
    {w2nData?.length ? (
      <div className="birdviewWrapper m-0">
        <ul className="birdview">
          {w2nData.map((creative, index) => {
            const commonProps = {
              creative,
              spent: creative.spent,
              language: creative.lang_id,
              campaign_name: creative.campaign_name,
              colors: getColors("Way2news"),
            };

            const typeMap = {
              full_image: <FullImage {...commonProps} length={1} />,
              gallery: <Gallery {...commonProps} />,
              full_video: <Fullvideo {...commonProps} />,
              half_video: <HalfVideo {...commonProps} />,
              promoted_image_story: <PromotedImage {...commonProps} />,
              promoted_video_story: <PromotedVideo {...commonProps} />,
              promoted_gallery: <PromotedGallery {...commonProps} />,
              webviewad: <WebView {...commonProps} />,
              commentad: <CommentAd {...commonProps} />,
              fullvideo_or_gif: <FullVideoOrGif {...commonProps} />,
            };

            return (
              <li key={creative.campaign_id || index}>
                {typeMap[creative.sub_type] || null}
              </li>
            );
          })}
        </ul>
      </div>
    ) : (
      <div className="p-4 text-center w-100 text-muted">
        No creatives found.
      </div>
    )}
  </div>
</SlDrawer>

      <Modal
        className="birdview-image-preview"
        show={see}
        onHide={() => setSee(false)}
      >
        <Modal.Header closeButton>Image Preview</Modal.Header>
        <Modal.Body>
          <img src={imgSrc} alt="" />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AdsPreviewer;
